/**
 * Legal pages live in the CMS like any other page, so these are editor-controlled
 * slugs. There is no ownership field to resolve them from (they own no collection),
 * so they stay constants — but when one is renamed, update it here *and* add a
 * `LEGACY_PATH_REDIRECTS` entry so the old URL keeps working.
 */
export const PRIVACY_POLICY_PATH = '/informativa-privacy';
export const COOKIE_POLICY_PATH = '/informativa-cookie';
export const COOKIE_PREFERENCES_HASH = '#cookie-preferences';
